'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getCurrentProtocol = require('../getCurrentProtocol.js');
var normDomain = require('../normDomain.js');
var secondLocation = require('../secondLocation.js');
require('../localStore.js');
require('../tslib.es6-cd939937.js');
require('../memoryStorage.js');
require('../_storageService-be0124c8.js');
require('lodash/shuffle');

function formatPath(path, withDeviceRestriction, accessData) {
    if (path === void 0) { path = null; }
    if (withDeviceRestriction === void 0) { withDeviceRestriction = true; }
    if (!path) {
        return null;
    }
    path = path.indexOf('/') === 0 ? path.slice(1) : path;
    var domain = secondLocation.secondLocation.isEnabled() ? secondLocation.secondLocation.getBackDomain() : accessData.backend;
    var url = new URL(getCurrentProtocol.getCurrentProtocol() + "//" + normDomain.normDomain(domain) + "/" + path);
    url.pathname = url.pathname.lastIndexOf('/') !== url.pathname.length - 1 ? url.pathname + '/' : url.pathname;
    if (withDeviceRestriction) {
        var deviceRestrictions = accessData.deviceRestrictions;
        if (deviceRestrictions && deviceRestrictions.length) {
            url.searchParams.set('d', deviceRestrictions.join(','));
        }
    }
    return url;
}

exports.formatPath = formatPath;
